import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  ACCESS_TOKEN,
} from "./actionTypes"

export const loginUser = user => {
  return {
    type: LOGIN_USER,
    payload: { user },
  }
}

export const loginSuccess = user => {
  return {
    type: LOGIN_SUCCESS,
    payload: user,
  }
}

export const logoutUser = () => {
  return {
    type: LOGOUT_USER,
  }
}

export const logoutUserSuccess = () => {
  return {
    type: LOGOUT_USER_SUCCESS,
    payload: {},
  }
}

export const setAccessToken = token => {
  return {
    type: ACCESS_TOKEN,
    payload: token,
  }
}

export const apiError = error => {
  return {
    type: API_ERROR,
    payload: error,
  }
}
